 /**
   * Set recently read posts to a cookie.
   */
  function isannointiliitto_setcookie(post_id) {
    var data = Cookies.getJSON('isannointiliitto_last_read');
    var max_length = 5;
    var posts = [];

    if (data) {
      posts = data;

      // move existing item to last (most recent)
      if (posts.indexOf(post_id) > -1) {
        posts.splice(posts.length + 1, 0, posts.splice(posts.indexOf(post_id), 1)[0]);
      }
      else {
        if (posts.length >= max_length) {
          posts.shift();
        }
        posts.push(post_id);
      }

      Cookies.remove('isannointiliitto_last_read');
    }
    else {
      posts.push(post_id);
    }

    Cookies.set('isannointiliitto_last_read', posts, { expires: 90 });
    return;
  }
